import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CompanyPage from "@/pages/CompanyPage";
import KdsPage from "@/pages/KdsPage";
import SadjaGroupPage from "@/pages/SadjaGroupPage";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App">
            <LanguageProvider>
            <BrowserRouter>
                <ScrollManager />
                <div className="grain-overlay" aria-hidden="true" />
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/companies/kharisma-damar-satya" element={<KdsPage />} />
                    <Route path="/companies/sadja-group" element={<SadjaGroupPage />} />
                    <Route path="/companies/:slug" element={<CompanyPage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
                <Footer />
                <Toaster theme="dark" position="bottom-right" />
            </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
